import Contentstack from 'contentstack';

export const FETCH_CONTENTSTACK_ASYNC_SUCCESS = 'FETCH_CONTENTSTACK_ASYNC_SUCCESS';
export const CONTENTSTACK_ASYNC_ERROR = 'CONTENTSTACK_ASYNC_ERROR';
export const FETCH_CONTENTSTACK_ASYNC_ACTION_START = 'FETCH_CONTENTSTACK_ASYNC_ACTION_START';

const contentstackApiKey = APP_CONFIG.contentstackApiKey;
const contentstackToken = APP_CONFIG.contentstackToken;
const contentstackEnv = APP_CONFIG.contentstackEnv;

const Stack = Contentstack.Stack(
  contentstackApiKey,
  contentstackToken,
  contentstackEnv
);

const ContentstackAsyncStart = () => ({
  type: FETCH_CONTENTSTACK_ASYNC_ACTION_START,
})

const fetchContentstackAsyncSuccess = (data) => ({
  type: FETCH_CONTENTSTACK_ASYNC_SUCCESS,
  payload: data,
});

const contentstackAsyncError = (error) => ({
  type: CONTENTSTACK_ASYNC_ERROR,
  payload: error,
});

/**
 * Fetch all entries from contentstack
 *
 */
export const fetchContentstackAsync = () => {
  return (dispatch) => {
    dispatch(ContentstackAsyncStart());
    return new Promise((resolve, reject) => {
      const Query = Stack.ContentType('dashboard').Query();
      Query
        .includeSchema()
        .toJSON()
        .find()
        .then(async function success(result) {
          const components = {
            heroBanner: result[0][0].components.find(item => Object.keys(item)[0] === 'hero_banner'),
            cardContainer: result[0][0].components.find(item => Object.keys(item)[0] === 'card_container'),
            featureCallout: result[0][0].components.find(item => Object.keys(item)[0] === 'feature_callout')
          };
          await dispatch(fetchContentstackAsyncSuccess(components))
          return resolve(components);
        }, function error(err) {
          dispatch(contentstackAsyncError(err));
          return reject(err);
        });
    })
  };
};
